

function CarouselIamge(props){

    const { id, name,src,onClick} = props
    
    return(
         <div className="flex one shadow center">
                <img src={src} className='car-img' id="car-img" onClick={onClick}></img>
         </div>
    )
}

export default CarouselIamge;